/* global $, ko, _, JSONideabooks */

$(function() {
    "use strict";

    if (typeof location.origin === 'undefined') {
        location.origin = location.protocol + '//' + location.host;
    }

    $(document).on('ready', function() {

        var $portfolio = $('.vendor-portfolio');
        var $collectionAddButton = $portfolio.find('.vendor-portfolio__upload-field');
        var $portfolioErrorBlock = $portfolio.find('.vendor-portfolio__upload-error');
        var $ideabookNameInput = $portfolio.find('.vendor-portfolio__collection-name-input');
        var $ideabooksView = $portfolio.find('.ideabooks-view');
        var $tooltip = $portfolio.find('.tooltip');

        function declOfNum (number, titles) {
            var cases = [2, 0, 1, 1, 1, 2];
            return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
        }

        // вью модель фотографии
        var PhotoViewModel = function (object) {
            this.id = object.photo_id;
            this.src = object.image_src;
            return this;
        };

        // вью модель идеабука
        var IdeabookViewModel = function (object) {
            this.id = object.id;
            this.name = ko.observable(object.name);
            this.deleteUrl = /^http/.test(object.deleteUrl) ? object.deleteUrl : location.origin + object.deleteUrl;
            this.editUrl   = /^http/.test(object.editUrl) ? object.editUrl : location.origin + object.editUrl;
            this.photos = ko.observableArray(object.photos);
            this.inputVisibility = ko.observable(false);
            this.size = ko.observable(object.size||0);
            this.notUploadedPhotosCount = ko.observable(object.notUploadedPhotosCount||0);
            this.processingPlateText = ko.computed(function () {
                if (this.notUploadedPhotosCount() < 1) {
                    return null;
                }
                else {
                    var c = this.notUploadedPhotosCount();
                    var plural = [
                        ' фотография загружена и будет обработана',
                        ' фотографии загружены и будут обработаны',
                        ' фотографий загружены и будут обработаны'
                    ];

                    return c + declOfNum(c, plural) + ' в течение нескольких минут';
                }
            }, this);

            this.focusHandler = ko.computed(function () {
                if (this.inputVisibility() === true || this.name() != '') {
                    $('[data-id="' + this.id + '"]').parent().next().find('input').focus();
                } else {
                    return false;
                }
            }, this);

            return this;
        };

        // добавление фото в идеабук
        IdeabookViewModel.prototype.addPhoto = function (object) {
            var photo = new PhotoViewModel(object);
            this.photos.push(photo);
        };

        // ловим клик по кнопке "+ Добавить фото"
        IdeabookViewModel.prototype.addPhotosThroughOverlay = function (data, event) {
            var $caller = $(event.target);

            if (!$caller.is('[data-photo-upload-overlay-options]')) {
                $caller = $caller.parents('[data-photo-upload-overlay-options]');
            }

            var specificOptions = _.extend(
                $caller.data().photoUploadOverlayOptions,
                {
                     insertionCallback   : "add-photos-to-ideabook-at-vendor-profile",
                     insertionButtonText : "Сохранить",
                     hideSpecials        : true,
                     specificIdeabook    : data.id,
                     limit               : 13
                }
            );

            var callbackObject = {
                name: 'add-photos-to-ideabook-at-vendor-profile',
                callbackFunction: function ($target, photos, ideabook, size, isLast) {

                    if (isLast) {
                        $(document).trigger('PhotoUploadOverlay::hide');
                    }

                    var photosInVendorPortfolio = [];
                    _.each(photos, function (photo) {
                        photosInVendorPortfolio.push({ photo_id: photo.id, image_src: photo.thumbnailSrc });
                    });

                    $(document).trigger('Portfolio::addPhotos', [photosInVendorPortfolio, data.id, size]);
                }
            };

            $(document).trigger('PhotoUploadOverlay::registerCallback', [
                callbackObject,
                function() {
                    $(document).trigger('PhotoUploadOverlay::show', [specificOptions, $caller]);
                }
            ]);
        };

        // удаляем идеабук.
        IdeabookViewModel.prototype.removeIdeabook = function (ideabook) {
            PortfolioView.ideabooks.remove(function(item) {
                return item.id === ideabook.id;
            });
            $('.js-gallery-select').find('option[value="' + ideabook.id + '"]').remove();
            removeIdeabookByAjax(ideabook.deleteUrl)
            .done(function() {
                $('#photo-upload-overlay').data('photoUploadOverlay').removeIdeabookById(ideabook.id);
            });
        };

        // удаление фото из идеабука
        IdeabookViewModel.prototype.removePhoto = function (photo) {
            this.photos.remove(function(item) {
                return item.id === photo.id;
            });
            ajaxRemovePhoto(photo.id, this.id);
        };

        // показываем поле редактирования имени
        IdeabookViewModel.prototype.showInput = function (ideabook, event) {
            var self = this;
            self.inputVisibility(true);
        };

        var setNewName = function (event, self) {
            if ($(event.target).parsley().validate() === true) {

                var ideabookName = $(event.target).val();
                ideabookName = ideabookName.toString();
                if (ideabookName === '') {
                    return false;
                }
                self.name(ideabookName);
                $('.js-gallery-select').find('option[value="' + self.id + '"]').text(ideabookName);
                ajaxRenameIdeabook(
                    {
                        ideabook: {
                            name        : self.name(),
                            _csrf_token : $portfolio.data('_csrf_token')
                        }
                    },
                    self.editUrl
                );

                var PhotoUploadOverlayIdeabook = $('#photo-upload-overlay').data('photoUploadOverlay').getIdeabookById(self.id);

                if (_(PhotoUploadOverlayIdeabook).isObject()) {
                    PhotoUploadOverlayIdeabook.name(self.name());
                }

                return true;
            }
        };

        var debouncedRenaming = _.debounce(function(event, self) {
            setNewName(event, self);
        }, 1000);

        // меняем имя идеабука
        IdeabookViewModel.prototype.changeName = function (ideabook, event) {
            var self = this;

            if (event.which === 13 || event.type === 'blur') {
                var hideInput = setNewName(event, self);
                if (hideInput) {
                    self.inputVisibility(false);
                }
            } else {
                debouncedRenaming(event, self);
                return true;
            }
        };

        // вью модель портфолио, содержит все идеабуки
        var PortfolioViewModel = function () {

            this.ideabooks = ko.observableArray();

            this.photosCount = ko.computed(function() {
                var photosCountsArray = [];
                _(this.ideabooks()).each(function (object) {
                    photosCountsArray.push(object.photos().length);
                });
                return _.reduce(photosCountsArray, function(memo, num) {
                    return memo + num;
                }, 0);
            }, this);

            this.importFromVk = function () {

                var $caller = $(event.target);

                if (!$caller.is('[data-photo-upload-overlay-options]')) {
                    $caller = $caller.parents('[data-photo-upload-overlay-options]');
                }

                var specificOptions = _.extend(
                    $caller.data().photoUploadOverlayOptions,
                    {
                        insertionCallback : "create-ideabook-at-vendor-profile",
                        limit             : 13
                    }
                );

                var callbackObject = {
                    name: 'create-ideabook-at-vendor-profile',
                    callbackFunction: function($target, photos, ideabook, size, isLast) {

                        if (isLast) {
                            $(document).trigger('PhotoUploadOverlay::hide');
                        }

                        PortfolioView.addIdeabook({
                            name                      : ideabook.name,
                            id                        : ideabook.id,
                            deleteUrl                 : ideabook.url + 'delete/',
                            editUrl                   : ideabook.url + 'edit/',
                            size                      : size,
                            notUploadedPhotosCount : size
                        });

                        var photosInVendorPortfolio = [];
                        _.each(photos, function(photo) {
                            photosInVendorPortfolio.push({ photo_id: photo.id, image_src: photo.thumbnailSrc });
                        });

                        $(document).trigger('Portfolio::addPhotos', [photosInVendorPortfolio, ideabook.id]);
                    }
                };

                $(document).trigger('PhotoUploadOverlay::registerCallback', [
                    callbackObject,
                    function() {
                        $(document).trigger('PhotoUploadOverlay::show', [specificOptions, $caller]);
                    }
                ]);
            };

            return this;
        };

        // считаем число идеабуков
        PortfolioViewModel.prototype.ideabooksValue = function () {
            return this.ideabooks().length;
        };

        // скрываем крутилку, когда все фотки загрузятся
        PortfolioViewModel.prototype.renderedHandler = function () {
            if ($ideabooksView.find('.vendor-tunnel__upload__portfolio').length === PortfolioView.ideabooksValue()) {
                toogleLoadingSpinner();
            }
        };

        // добавляем идеабук
        PortfolioViewModel.prototype.addIdeabook = function (object) {
            var ideabook = new IdeabookViewModel(object);
            this.ideabooks.unshift(ideabook);
            $ideabookNameInput.val('');
            return ideabook;
        };

        IdeabookViewModel.prototype.imageLoadHandler = function (element, event) {
            var $img = $(event.target);
            if ($img.width() >= $img.height()) {
                $img.addClass('inscribed-photo_vertically');
            }
            else {
                $img.addClass('inscribed-photo_horizontally');
            }
        };

        var PortfolioView = new PortfolioViewModel();

        if ($portfolio.length > 0) {
            ko.applyBindingsIsNotIsBound(PortfolioView, $portfolio[0]);
        }

        var showUploadOverlay = function () {
            var $caller = $(this);
            var specificOptions = _.extend(
                $caller.data('photoUploadOverlayOptions') || {},
                {
                     hiddenSections      : ["insert-from-ideabook", "mass-import-from-vk", "import-from-vk"],
                     insertionCallback   : "create-ideabook-at-vendor-profile",
                     insertionButtonText : "Сохранить",
                     isOnlyNewIdeabook   : true,
                     hideSpecials        : true,
                     newIdeabookName     : $ideabookNameInput.val() || '',
                     limit               : 13
                }
            );

            var callbackObject = {
                name: 'create-ideabook-at-vendor-profile',
                callbackFunction: function($target, photos, ideabook, size, isLast) {

                    if (isLast) {
                        $(document).trigger('PhotoUploadOverlay::hide');
                    }

                    PortfolioView.addIdeabook({
                        name                      : ideabook.name,
                        id                        : ideabook.id,
                        deleteUrl                 : ideabook.url + 'delete/',
                        editUrl                   : ideabook.url + 'edit/',
                        size                      : size,
                        notUploadedPhotosCount    : size
                    });

                    var photosInVendorPortfolio = [];
                    _.each(photos, function(photo) {
                        photosInVendorPortfolio.push({ photo_id: photo.id, image_src: photo.thumbnailSrc });
                    });

                    $(document).trigger('Portfolio::addPhotos', [photosInVendorPortfolio, ideabook.id]);
                }
            };

            $(document).trigger('PhotoUploadOverlay::registerCallback', [
                callbackObject,
                function() {
                    $(document).trigger('PhotoUploadOverlay::show', [specificOptions, $caller]);
                }
            ]);
        };

        // отправка запроса на удаление идеабука
        var removeIdeabookByAjax = function (url) {
            var removingRequest = {
                url: url,
                method: 'POST'
            };

            return $.ajax(removingRequest)
            .fail(showError);
        };

        // отправка запроса на переименование идеабука
        var ajaxRenameIdeabook = function (object, url) {
            var renameIdeabookRequest = {
                url:      url,
                data:     $.param(object),
                method:   'post',
                dataType: 'json'
            };

            return $.ajax(renameIdeabookRequest)
            .always()
            .fail(showError);
        };

        // выводим ошибку, если ajax не прошел или сервер вернул ошибку
        var showError = function (xhr) {
            if (typeof(xhr.responseJSON) !== 'undefined' && typeof(xhr.responseJSON.error) !== 'undefined') {
                $portfolioErrorBlock.html(xhr.responseJSON.error);
            }
            else {
                $portfolioErrorBlock.html('Произошла ошибка, попробуйте еще раз.');
            }

            $portfolioErrorBlock.show();
        };

        // скрываем/показываем лоадер
        var toogleLoadingSpinner = function (show) {
            typeof show === 'undefined' ? show = $portfolio.hasClass('vendor-portfolio-loading') : show = show;
            $portfolio.toggleClass('vendor-portfolio-loading', show);
        };

        // получаем ссылки на фотки и вставляем фотки в идеабук
        var insertPhotos = function (event, photos, ideabookId, size) {

            $portfolioErrorBlock.hide();

            var photosCount = parseInt(photos.length);

            if (!photosCount) {
                return;
            }

            var ideabook = _(PortfolioView.ideabooks()).findWhere({id: ideabookId});

            if (size) {
                ideabook.size(ideabook.size() + size);
                ideabook.notUploadedPhotosCount(ideabook.notUploadedPhotosCount() + size);
            }

            _.each(photos, function (object) {
                ideabook.addPhoto(object);
            });
        };

        var ajaxRemovePhoto = function (id, ideabookId) {

            $portfolioErrorBlock.hide();

            var removePhotoRequest = {
                url: location.origin + '/ideabooks/unpin/',
                data: {photo_id: id, ideabook_id: ideabookId},
                dataType: 'json',
                type: 'POST',
                cache: false
            };

            $.ajax(removePhotoRequest)
            .done()
            .fail(showError);
        };

        // скрываем подсказку
        var tryHideTooltip = function (event) {
            if ($(event.target).val().length >= 3 || event.type === 'click') {
                $tooltip.removeClass('vendor-portfolio__tooltip_showed');
            }
        };

        if (typeof JSONideabooks !== 'undefined') {

            _.each(JSONideabooks.reverse(), function (ideabook) {

                PortfolioView.addIdeabook(
                    {
                        name                      : ideabook.name,
                        id                        : Number(ideabook.id),
                        deleteUrl                 : ideabook.delete_url,
                        editUrl                   : ideabook.edit_url,
                        photos                    : ideabook.photos,
                        size                      : ideabook.size||0,
                        notUploadedPhotosCount : ideabook.notUploadedPhotosCount||0
                    }
                );
            });
        }

        $(document).on('Portfolio::addPhotos', insertPhotos);

        $collectionAddButton.on('click', showUploadOverlay);

        $ideabookNameInput.on('keydown', tryHideTooltip);

        $tooltip.on('click', '.tooltip__close', tryHideTooltip);
    });

});
